// Compiled at 2026-05-13T13:50:05.286Z
import { System } from "../../Module/$modules.js";
import { addQueryParametersToUrl } from "@lg/shared";
import * as Llama from "./Llama.js";
import * as This from "./Llama.js";
import { ScreenDefinition } from "@lg/shared";
import { VerifyExpenses } from "../../Screen/Llama/VerifyExpenses.js";
import { ScanReceipt } from "../../Screen/Llama/ScanReceipt.js";
import { OpenReceiptButtonInclude } from "../../Screen/Llama/OpenReceiptButtonInclude.js";
import { MyExpenses } from "../../Screen/Llama/MyExpenses.js";
import { MainLayoutSidebar } from "../../Screen/Llama/MainLayoutSidebar.js";
import { MainLayoutHeader } from "../../Screen/Llama/MainLayoutHeader.js";
import { MainLayout } from "../../Screen/Llama/MainLayout.js";
import { LoaderDots } from "../../Screen/Llama/LoaderDots.js";
import { InvoicePreparation } from "../../Screen/Llama/InvoicePreparation.js";
import { Home } from "../../Screen/Llama/Home.js";
import { ExpenseCardInclude } from "../../Screen/Llama/ExpenseCardInclude.js";
import { AllExpenses } from "../../Screen/Llama/AllExpenses.js";
import { FrontendScreenBridge } from "@lg/ng-shared";

// Auto-generated by Lowgile
export const $ModuleId = 'Llama.js';

export * from "../../StaticEntity/Llama/ExpenseStatus.js";
export * from "../../StaticEntity/Llama/ExpensePaidBy.js";
export * from "../../StaticEntity/Llama/ExpenseCategory.js";
export * from "../../StaticEntity/Llama/Currency.js";
export * from "../../Entity/Llama/ReceiptHelper.js";
export * from "../../Entity/Llama/Project.js";
export * from "../../Entity/Llama/ExpenseReceipt.js";
export * from "../../Entity/Llama/Expense.js";
export * from "../../Entity/Llama/EmployeeProjectFavorite.js";
export * from "../../Entity/Llama/Customer.js";
export * from "../../ServerDataStore/Llama/ExpensesDataStore.js";
export * from "../../UserDefinedConfiguration/Llama/MenuState.js";
export * from "../../Label/Llama/$translations.js";
export * from "../../Resource/Llama/$resources.js";
export { $Config } from "../../ConfigurationItem/Llama/config.js";
export * as $Process from "../../Process/Llama/$processes.js";
export * from "../../Role/Llama/$roles.js";
export * from "../../Permission/Llama/$permissions.js";

export const $Screens = {
    VerifyExpenses: {
        moduleId: 'Llama', boId: 'VerifyExpenses', component: VerifyExpenses, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/VerifyExpenses', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    ScanReceipt: {
        moduleId: 'Llama', boId: 'ScanReceipt', component: ScanReceipt, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/ScanReceipt', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    OpenReceiptButtonInclude: {
        moduleId: 'Llama', boId: 'OpenReceiptButtonInclude', component: OpenReceiptButtonInclude, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/OpenReceiptButtonInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        receiptId: string,
    }, {
        }>,
    MyExpenses: {
        moduleId: 'Llama', boId: 'MyExpenses', component: MyExpenses, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/MyExpenses', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    MainLayoutSidebar: {
        moduleId: 'Llama', boId: 'MainLayoutSidebar', component: MainLayoutSidebar, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/MainLayoutSidebar', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    MainLayoutHeader: {
        moduleId: 'Llama', boId: 'MainLayoutHeader', component: MainLayoutHeader, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/MainLayoutHeader', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    MainLayout: {
        moduleId: 'Llama', boId: 'MainLayout', component: MainLayout, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/MainLayout', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        screenTitle?: string,
        isForExternalUser?: boolean,
    }, {
        }>,
    LoaderDots: {
        moduleId: 'Llama', boId: 'LoaderDots', component: LoaderDots, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/LoaderDots', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    InvoicePreparation: {
        moduleId: 'Llama', boId: 'InvoicePreparation', component: InvoicePreparation, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/InvoicePreparation', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    Home: {
        moduleId: 'Llama', boId: 'Home', component: Home, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/Home', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    ExpenseCardInclude: {
        moduleId: 'Llama', boId: 'ExpenseCardInclude', component: ExpenseCardInclude, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/ExpenseCardInclude', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        expense?: This.Expense,
        projectsOptions?: This.Project[],
    }, {
        onVerified: string,
    }>,
    AllExpenses: {
        moduleId: 'Llama', boId: 'AllExpenses', component: AllExpenses, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/AllExpenses', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
};
